import CaseFolders from "../CaseFolders";
import Notifications from "../Notifications";
import Overview from "../Overview";
import PaymentHistory from "../PaymentHistory";
import AppealAssignedNo from "../AppealAssignedNo";
import Settings from "../Settings";

import ViewCaseFolder from "../case-folder/ViewCaseFolder";

export const Registrar1PaymentRoute = [
  {
    title: "Overview",
    path: "/registrar1-payment/overview",
    component: Overview,
  },
  {
    title: "Case Folders",
    path: "/registrar1-payment/case-folders",
    component: CaseFolders,
  },

  {
    title: "View Case Folder",
    path: "/registrar1-payment/case-folders/view",
    component: ViewCaseFolder,
  },

  {
    title: "Assigned Appeal No",
    path: "/registrar1-payment/assigned-appeal",
    component: AppealAssignedNo,
  },
  {
    title: "Payment history",
    path: "/registrar1-payment/payment-history",
    component: PaymentHistory,
  },
  {
    title: "Notification",
    path: "/registrar1-payment/notification",
    component: Notifications,
  },
  {
    title: "Setting",
    path: "/registrar1-payment/setting",
    component: Settings,
  },
];
